import { useEffect, useState } from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';
import Signup from '../pages/Login/Signup';
import Login from '../pages/Login/Login';
import CheckSignupMail from '../pages/Login/CheckSignupMail';
import ResetPassword from '../pages/Login/ResetPassword';
import CheckResetMail from '../pages/Login/CheckResetMail';
import ForgetPassword from '../pages/Login/ForgetPassword';
import ResetSuccess from '../pages/Login/ResetSuccess';
import ActivateAccount from '../pages/Login/ActivateAccount';
import ActivateSuccess from '../pages/Login/ActivateSuccess';
import Initializing from '../pages/Login/Initializing';
import Warning from '../pages/Login/Warning';
import PermissionDenied from '../pages/Login/PermissionDenied';
import {
    LOGIN_ACTIVATEACCOUNT,
    LOGIN_ACTIVATESUCCESS,
    LOGIN_CHECKRESETMAIL,
    LOGIN_CHECKSIGNMAIL,
    LOGIN_FORGETPASSWORD,
    LOGIN_INITIALIZING,
    LOGIN_LOGIN,
    LOGIN_PERMISSIONDENIED,
    LOGIN_RESETPASSWORD,
    LOGIN_RESETSUCCESS,
    LOGIN_SIGNUP,
    LOGIN_WARNING,
    ROUTE_DASHBOARD
} from '../constants';
import '../style/Login.css';
import LoginApi from '../api/LoginApi';
import { useNavigate } from 'react-router-dom';

const LoginLayout = () => {
    const navigate = useNavigate();
    const [loginPage, setLoginPage] = useState(LOGIN_LOGIN);

    useEffect(() => {
        const checkLoginStatus = async () => {
            try {
                const res = await LoginApi.checkStatus();
                if (res.data.isAuthenticated) {
                    navigate(ROUTE_DASHBOARD);
                }
            } catch (error) {
                console.error("checkLoginStatus error: ", error);
            }
        };

        checkLoginStatus();

        const interval = setInterval(checkLoginStatus, 60000);

        return () => clearInterval(interval);
    }, []);

    return (
        <Box className="login-layout">
            {/* <Box className="login-layout_buttons">
                <ButtonBox text="Activate account" onClick={() => setLoginPage(LOGIN_ACTIVATEACCOUNT)} />
                <ButtonBox text="Reset password" onClick={() => setLoginPage(LOGIN_RESETPASSWORD)} />
                <ButtonBox text="Warning" onClick={() => setLoginPage(LOGIN_WARNING)} />
                <ButtonBox text="Permission denied" onClick={() => setLoginPage(LOGIN_PERMISSIONDENIED)} />
            </Box> */}

            <Box className="login-layout_background" />

            <Container maxWidth="sm" disableGutters className="login-layout_container">
                <Typography className="login-layout_title">
                    IIoT Platform
                </Typography>

                <Paper className="login-layout_card">
                    <Box className='line_box' />
                    {loginPage === LOGIN_LOGIN && <Login setLoginPage={setLoginPage} />}
                    {loginPage === LOGIN_SIGNUP && <Signup setLoginPage={setLoginPage} />}
                    {loginPage === LOGIN_ACTIVATEACCOUNT && <ActivateAccount setLoginPage={setLoginPage} />}
                    {loginPage === LOGIN_ACTIVATESUCCESS && <ActivateSuccess setLoginPage={setLoginPage} />}
                    {loginPage === LOGIN_INITIALIZING && <Initializing setLoginPage={setLoginPage} />}
                    {loginPage === LOGIN_CHECKSIGNMAIL && <CheckSignupMail />}
                    {loginPage === LOGIN_FORGETPASSWORD && <ForgetPassword setLoginPage={setLoginPage} />}
                    {loginPage === LOGIN_RESETPASSWORD && <ResetPassword setLoginPage={setLoginPage} />}
                    {loginPage === LOGIN_CHECKRESETMAIL && <CheckResetMail setLoginPage={setLoginPage} />}
                    {loginPage === LOGIN_RESETSUCCESS && <ResetSuccess setLoginPage={setLoginPage} />}
                    {loginPage === LOGIN_WARNING && <Warning setLoginPage={setLoginPage} />}
                    {loginPage === LOGIN_PERMISSIONDENIED && <PermissionDenied />}
                </Paper>
            </Container>
        </Box>
    );
};

export default LoginLayout;
